import type { MetaTrackEvent } from '@repo/single-spa';
import { clearAttribution } from '@repo/utils';

type Fbq = (...args: unknown[]) => void;

// TT-289: one standard event through the Pixel; eventID pairs it with the server copy (TT-290)
export function trackMetaEvent(
  { event, eventId }: MetaTrackEvent,
  fbq: Fbq | undefined = (window as Window & { fbq?: Fbq }).fbq
): void {
  if (typeof fbq !== 'function') {
    return;
  }
  if (eventId) {
    fbq('track', event, {}, { eventID: eventId });
  } else {
    fbq('track', event, {});
  }
}

/**
 * Registration is done: track it, then drop the campaign this bundle may still hold
 * in memory from before consent, so a later yes does not store it again.
 */
export function handleRegistrationTrack(
  event: MetaTrackEvent,
  fbq: Fbq | undefined = (window as Window & { fbq?: Fbq }).fbq
): void {
  try {
    trackMetaEvent(event, fbq);
  } finally {
    clearAttribution();
  }
}
